import React, { useEffect, useRef } from 'react';
import styles from './FolderPathAutocomplete.module.css';

interface FolderPathAutocompleteProps {
  folders: string[];
  selectedIndex: number;
  onSelect: (folder: string) => void;
  onSelectedIndexChange: (index: number) => void;
  position: { top: number; left: number };
}

export const FolderPathAutocomplete: React.FC<FolderPathAutocompleteProps> = ({
  folders,
  selectedIndex,
  onSelect,
  onSelectedIndexChange,
  position,
}) => {
  const resultListRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (resultListRef.current && itemRefs.current[selectedIndex]) {
      const selectedItem = itemRefs.current[selectedIndex];
      if (selectedItem) {
        selectedItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }, [selectedIndex]);

  if (folders.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.autocomplete}
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
    >
      <div className={styles.resultList} ref={resultListRef}>
        {folders.map((folder, index) => (
          <div
            key={folder}
            ref={(el) => (itemRefs.current[index] = el)}
            className={`${styles.resultItem} ${index === selectedIndex ? styles.selected : ''}`}
            onClick={() => onSelect(folder)}
            onMouseEnter={() => onSelectedIndexChange(index)}
          >
            <div className={styles.resultPath}>{folder}</div>
          </div>
        ))}
      </div>
      <div className={styles.footer}>
        <kbd>↑↓</kbd> Navigate · <kbd>Enter</kbd> Select · <kbd>Esc</kbd> Cancel
      </div>
    </div>
  );
};
